import DOMPurify from 'dompurify'

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['a', 'b', 'strong', 'em', 'br', 'span'],
  ALLOWED_ATTR: ['href', 'style', 'class'],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|tel|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i
}

export function sanitize(dirty) {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty, SANITIZE_CONFIG)
}
